<template>
  <div class="main">
    <div class="img-wrap">
      <img class="img" src="./img/yvlongboche.png" alt="">
    </div>
    <div class="content-wrap">
      <div class="content-title">玉龙泊车APP</div>
      <div class="content">为车主提供查找车位、导航、缴费支付、消息通知、查看停车记录、参与优惠活动、反馈意见等功能，方便市民出行！</div>
      <div class="btn-box">
        <div class="btn" @click="downloadAndroid">
          <img class="btn-img" src="./img/download.png" alt="">
          安卓客户端
        </div>
        <div class="btn" @click="downloadIos">
          <img class="btn-img" src="./img/download.png" alt="">
          ios客户端
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mainV2',
  data () {
    return {}
  },
  methods: {
    downloadAndroid () {
      window.open(`https://app.cfylcx.com/app/AiPark_cf.apk`)
    },
    downloadIos () {
      window.open(`https://apps.apple.com/cn/app/id1659848904`)
    }
  }
}
</script>

<style scoped>
.main {
  user-select: none;
  width: 100%;
  min-height: 500px;
  display: flex;
  box-sizing: border-box;
  padding: 100px 100px;
  margin-bottom: 100px;
}
.img-wrap {
  flex: 1 0;
}
.img {
  width: 350px;
}
.content-wrap {
  flex: 1 0;
  text-align: left;
}
.content-title {
  font-weight: 700;
  font-style: normal;
  font-size: 48px;
  line-height: 42px;
  margin-top: 65px;
}
.content {
  font-weight: 400;
  font-style: normal;
  font-size: 36px;
  line-height: 42px;
  margin-top: 65px;
}
.btn-box {
  margin-top: 65px;
  display: flex;
}
.btn {
  margin-right: 30px;
  height: 45px;
  background-color: #527bff;
  border-radius: 23px;
  padding-left: 60px;
  padding-right: 20px;
  line-height: 48px;
  color: white;
  cursor: pointer;
  position: relative;
}
.btn-img {
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/mainV2.vue